export const GET_ORDER_PDF_STATES="pay-order/GET_ORDER__PDF_STATES";
export const SET_ORDER__PDF_STATES="pay-order/SET_ORDER__PDF_STATES";

export const getDriverOrderPDFStates=(data)=>{
    return{
        type:GET_ORDER_PDF_STATES,
        payload:data
    }
}
export const setDriverOrderPDFStates=(data)=>{
    return{
        type:SET_ORDER__PDF_STATES,
        payload:data
    }
}